<template>
  <div class="field">
    <select name="country" v-model="selectedCountry" @change="countrySelected($event)" :disabled="disabled">
      <option v-for="(country, index) in countries" :key="index" :value="country">
        {{ country }}
      </option>
    </select>
  </div>
</template>

<script>
import countries from '@/assets/countries.json';

export default {
  name: 'CountrySelector',

  data() {
    return {
      selectedCountry: '',
      countries: countries.map(country => country.name),
      countryCodes: countries.map(country => country.code),
    };
  },

  props: {
    country: String,
    disabled: Boolean,
  },

  created() {
    this.selectedCountry =
      this.country
        .toLowerCase()
        .charAt(0)
        .toUpperCase() + this.country.slice(1).toLowerCase();
  },

  methods: {
    countrySelected(event) {
      const country = this.selectedCountry;
      const countryCode = this.countryCodes[event.target.selectedIndex];
      this.$emit('countrySelected', { country, countryCode });
    },
  },
};
</script>

<style></style>
